import { Spinner, SpinnerSize, Stack } from 'office-ui-fabric-react'

import React from 'react'
import { ScreenHeader } from '../../../../Components/ScreenHeader'
import { ChildProps } from 'react-apollo/types'
import { graphql } from 'react-apollo'
import {
  ReferencesResponse,
  getReferencesChains,
  getReferencesChainsQuery,
} from '../../../../Api/references'
import { ReferencesList } from './ReferencesListScreen'
import { SupplyChainConfiguration } from './SupplyChainConfiguration'

export interface InputProps {}

const ReferencesScreenView: React.FC<
  ChildProps<InputProps, ReferencesResponse>
> = (props) => {
  const { data } = props
  const isLoading = data && data!.loading

  const [isSupplyChainConfigurationOpen, setIsSupplyChainConfigurationOpen] =
    React.useState(false)

  const {
    referencesChains = [],
    session = { accountDisplayName: '' },
    sellerDomain = { domain: '' },
  } = data || {}

  return (
    <Stack
      className="screen"
      horizontalAlign="start"
      verticalAlign="start"
      verticalFill
      style={{ width: '100%' }}
    >
      <ScreenHeader
        path={['Sellers.json', 'References from 3rd party buyers']}
        buttons={[
          {
            name: 'New Supply Chain',
            icon: 'Add',
            disabled: isLoading,
            onClick: () => setIsSupplyChainConfigurationOpen(true),
          },
        ]}
      />
      <Stack
        className="references-screen"
        horizontalAlign="center"
        verticalAlign="start"
        horizontal
        wrap
        styles={{
          root: {
            width: '100%',
            overflow: 'auto',
          },
          inner: {
            padding: 60,
          },
        }}
      >
        {isLoading ? (
          <Stack
            horizontalAlign="center"
            verticalAlign="center"
            verticalFill
            style={{ width: '100%' }}
          >
            <Spinner
              size={SpinnerSize.large}
              labelPosition={'right'}
              label="Loading"
            />
          </Stack>
        ) : (
          <>
            <ReferencesList
              referencesChains={referencesChains}
              accountDisplayName={session.accountDisplayName}
              ownDeclarationDomain={
                sellerDomain ? sellerDomain.domain || undefined : undefined
              }
              onUpdated={() => getReferencesChains()}
            />
            {isSupplyChainConfigurationOpen && (
              <SupplyChainConfiguration
                onClose={() => setIsSupplyChainConfigurationOpen(false)}
                onSaved={() => {
                  setIsSupplyChainConfigurationOpen(false)
                  getReferencesChains()
                }}
              />
            )}
          </>
        )}
      </Stack>
    </Stack>
  )
}

const withGql = graphql<InputProps, ReferencesResponse>(
  getReferencesChainsQuery,
  {
    options: () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }),
  }
)

export const ReferencesScreen = withGql(ReferencesScreenView)
